export default __webpack_public_path__ + "static/grain-6aeff847d1d8023f3e35293c6aebf85e.png";